<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
/* Mobile sticky ATC: move product form to body so fixed survives Related / Footer scroll */
(function () {
  var MQ = 767;
  var BAR_ID = 'mobile-sticky-atc-bar';
  var moved = false;
  var productForm = null;
  var home = null;

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function isMobile() {
    return window.matchMedia('(max-width: ' + MQ + 'px)').matches;
  }

  function getProductForm() {
    return document.querySelector(
      '.template-product .productView-buttons product-form.productView-form, .productView-buttons product-form.productView-form'
    );
  }

  function ensureBar() {
    var bar = document.getElementById(BAR_ID);
    if (!bar) {
      bar = document.createElement('div');
      bar.id = BAR_ID;
      bar.className = 'mobile-sticky-atc-bar';
      document.body.appendChild(bar);
    }
    return bar;
  }

  function moveToSticky() {
    productForm = productForm || getProductForm();
    if (!productForm || moved) return;

    home = productForm.parentElement;
    if (!home) return;

    if (!home.querySelector('[data-mobile-sticky-spacer]')) {
      var spacer = document.createElement('div');
      spacer.setAttribute('data-mobile-sticky-spacer', '');
      spacer.className = 'mobile-sticky-atc-spacer';
      home.insertBefore(spacer, productForm);
    }

    ensureBar().appendChild(productForm);
    moved = true;
    document.body.classList.add('has-mobile-sticky-atc');
  }

  function moveHome() {
    if (!moved || !productForm || !home) return;

    var spacer = home.querySelector('[data-mobile-sticky-spacer]');
    if (spacer) {
      home.insertBefore(productForm, spacer.nextSibling);
    } else {
      home.appendChild(productForm);
    }

    moved = false;
    document.body.classList.remove('has-mobile-sticky-atc');

    var bar = document.getElementById(BAR_ID);
    if (bar && !bar.children.length) bar.remove();
  }

  function sync() {
    if (!isProductPage()) return;
    if (isMobile()) moveToSticky();
    else moveHome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  window.addEventListener('resize', sync);
  document.addEventListener('shopify:section:load', function () {
    moved = false;
    productForm = null;
    home = null;
    sync();
  });
})();
